import { createAsyncThunk } from '@reduxjs/toolkit';

import { FriendsResponse } from "../types";
import {snackbarAction} from "../../errors/SnackbarSlice";

export const fetchFriends = createAsyncThunk(
    'friends/fetchFriends',
    async (status: number = 1, thunkAPI) => {
        const {extra, rejectWithValue, dispatch} = thunkAPI;

        try {
            // @ts-ignore
            const response = await extra.api.get<FriendsResponse>(
                'relationship/friend',
                {
                    params: { status },
                }
            );

            if (!response.data.success) {
                return rejectWithValue('error')
            }

            return response.data;
        } catch (error: any) {
            dispatch(snackbarAction.addError('INTERNAL_ERROR'));
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch friends');
        }
    }
);
